import { createContext, PropsWithChildren, useCallback, useMemo } from 'react'
import gsap from 'gsap'
import { ScrollToOptions } from 'lenis'
import ReactLenis, { useLenis } from 'lenis/react'

import Controller from './components/controller'
import Scrollbar from './components/scrollbar'

export type Context = {
  // eslint-disable-next-line no-unused-vars
  scrollTo: (target: number | string | HTMLElement, options?: ScrollToOptions) => void
}

export const LenisContext = createContext<Context | undefined>(undefined)

const LenisProvider = ({ children }: PropsWithChildren) => {
  const lenis = useLenis()

  const scrollTo = useCallback(
    (target: number | string | HTMLElement, options?: ScrollToOptions) => {
      lenis?.scrollTo(target, {
        duration: 2.5,
        easing: gsap.parseEase('expo.inOut'),
        ...options
      })
    },
    [lenis]
  )

  const contextValue = useMemo(() => ({ scrollTo }), [scrollTo])

  return (
    <LenisContext.Provider value={contextValue}>
      <Controller />
      {children}
      <Scrollbar />
    </LenisContext.Provider>
  )
}

const LenisRoot = ({ children }: PropsWithChildren) => {
  return (
    <ReactLenis root>
      <LenisProvider>{children}</LenisProvider>
    </ReactLenis>
  )
}

export default LenisRoot
